import { WidgetDefinition } from './types';
import { FleetUsageWidget } from '@/components/widgets/usage/FleetUsageWidget';
import { TrackingUsageWidget } from '@/components/widgets/usage/TrackingUsageWidget';

export const usageWidgetDefinitions: WidgetDefinition[] = [
  {
    type: 'fleet-usage',
    title: 'Uso FleetONE',
    description: 'Monitoramento de uso dos recursos do FleetONE',
    icon: 'Truck',
    systemCode: 'fleet_management',
    defaultSize: {
      w: 3,
      h: 2,
    },
    component: FleetUsageWidget,
  },
  {
    type: 'tracking-usage',
    title: 'Uso TrackingONE',
    description: 'Monitoramento de uso dos recursos do TrackingONE',
    icon: 'Radio',
    systemCode: 'gps_tracking',
    defaultSize: {
      w: 3,
      h: 2,
    },
    component: TrackingUsageWidget,
  },
];
